import React from 'react'
import PropTypes from 'prop-types'
import {
  getImageSrcBasedOnOptions,
  ConfiguredVehicle,
  ImageSelector
} from 'containers'
import { ImagesRotator, Disclaimer } from 'AtomicContainers'
import { Radium } from 'higher-order-components'
import BackgroundImage from './background-image.png'
import { H5, Caption, LoadingIcon, StarIcon, A, Content, Space, Button } from 'AtomicComponents';

const descriptionText = description =>
  description && (
    <p style={styles.description} data-test="description">
      {description}
    </p>
  )

const Icon360 = ({ isTextOutside }) => (
  <svg style={{ height: '1.3em', paddingLeft: '10px' }} viewBox="0 0 30 26">
    <path
      fill={isTextOutside ? '#191919' : '#fff'}
      d="M0.83,8C0.83,3.59,7.15,0,15,0h0.1c7.8,0,14.12,3.59,14.12,8a5,5,0,0,1-.86,2.75C25.82,8,20.79,6.19,15,6.19S4.18,8,1.68,10.75A5,5,0,0,1,.83,8ZM29,11.56h0c-1.75,2.52-5.59,4.44-10.3,5.11V13.83L8.14,19.91,18.66,26V22.86C25.17,21.94,30,18.61,30,14.65V8.87h0a5.51,5.51,0,0,1-1,2.68h0Zm-22.58,10C2.53,20,0,17.52,0,14.65V8.87H0a5.51,5.51,0,0,0,1,2.68H1a11.66,11.66,0,0,0,5.36,3.83v6.19H6.42Z" />
  </svg>
)

const downArrow = () => (
  <svg style={{ width: '1em' }} viewBox="0 0 9 5">
    <path fill="inherit" d="M0 .7L.7 0l3.8 3.6L8.3 0l.7.7L4.5 5 0 .7z" />
  </svg>
)
const renderImageSelector = (step, options, onChange, selectIndex) =>
  step.radioGroup.map((radio, index) => {
    const props = {
      onChange: onChange,
      options: options[radio.groupName],
      active: options[radio.groupName].indexOf(options[radio.itemName]),
      only: options[radio.groupName].length <= 1
    }
    if (index === 0) {
      return <ImageSelector key={index} {...props} />
    }
  })

class RenderConfiguredVehicle extends React.PureComponent {
  render() {
    const {
      display360,
      step,
      isSelectColorInterior,
      options,
      onChange,
      selectIndex,
      showDescription,
      display360Status,
      price,
      includeSafetyModel = false,
      finance,
      background
    } = this.props
    if (!step.radioGroup) return null
    const newSelectIndex = selectIndex === undefined ? 0 : selectIndex
    if (!step.radioGroup[newSelectIndex]) return null
    const activeOption = options[step.radioGroup[newSelectIndex].itemName]
    const imageSrc = getImageSrcBasedOnOptions(
      display360Status && display360,
      options,
      activeOption,
      step,
      isSelectColorInterior,
    )

    return (
      <div>
        <div style={[background && styles.vehicleBackground(true), styles.statBase]}>
          <div style={styles.vehicleWrapper}>
            {step.imageSelector && renderImageSelector(step, options, onChange)}
            {!step.imageSelector && (
              <div style={{ position: 'relative' }}>
                {!this.props.compact && this.props.display360 &&
                  !display360Status &&
                  !isSelectColorInterior && (
                    <div
                      style={{
                        position: 'absolute',
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                        zIndex: 10
                      }}>
                      <Button
                        onClick={() => {
                          this.props.changeDisplay360Status(true)
                        }}
                        styleName="whiteOutlinedWithOpacity"
                        display="inline">
                        VIEW 360°
                        <Icon360 />
                      </Button>
                    </div>
                  )}
                {(!display360Status || isSelectColorInterior) && (
                  <ConfiguredVehicle isFadeAnimation key={newSelectIndex} src={imageSrc} />
                )}
                {display360Status && !isSelectColorInterior && (
                  <ImagesRotator
                    imagesSrc={imageSrc}
                    customTextStyle={{
                      position: 'fixed',
                      bottom: '5em',
                      left: 0,
                      right: 0,
                      background:
                        'linear-gradient(to top, rgba(245,245,245,1), rgba(245,245,245,0))',
                      padding: '5em 0 1em'
                    }} />
                )}
                {this.props.compact &&
                  this.props.display360 &&
                  !display360Status &&
                  !isSelectColorInterior && (
                    <div
                      style={{
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                        zIndex: 10
                      }}>
                      <Button
                        onClick={() => {
                          this.props.changeDisplay360Status(true)
                        }}
                        styleName="blackOutlined"
                        display="inline">
                        VIEW 360°
                        <Icon360 isTextOutside />
                      </Button>
                    </div>
                  )}
              </div>
            )}
          </div>
          <div style={[
            { boxSizing: "border-box", overflow: "hidden", textAlign: "left" },
            step.features && options.grade.features ? { minWidth: "365px", padding: "16px 0 16px 32px" } : { height: "0", width: "0" }
          ]}>
            <div style={styles.feature}>
              <H5 withDetails>{options.grade.name}</H5>
              {
                price && price.price && price.disclaimer ?
                  <A
                    withoutStyle
                    onClick={(event) => {
                      if (event && event.target && event.target.querySelector('button')) {
                        event.target.querySelector('button').click()
                      }
                    }}>
                    <Caption>From</Caption> <span style={{ fontSize: "20px" }}>${includeSafetyModel ? price.safetyModelPrice.toLocaleString() : price.price.toLocaleString()}</span>
                    <Disclaimer Icon={StarIcon}>
                      {price.disclaimer}
                    </Disclaimer>
                  </A>
                  : <LoadingIcon
                    style={{
                      width: "16px",
                      height: "16px"
                    }}
                  />
              }
            </div>
            {
              options.engine.safetyModelCode &&
              this.props.safetyModel
            }
            <Space />
            <Content textAlign="left">
              <label><b>
                {
                  options.grade.featuresHeading ?
                  options.grade.featuresHeading :
                  (options.grades.length === 1 ||
                    options.grades.indexOf(options.grade) === 0 ||
                    options.grades.length === ((options.grades.indexOf(options.grade)) - 1)) ?
                    "Base features:" :
                    `In addition to ${options.grades[options.grades.indexOf(options.grade) - 1].name}:`
                }
              </b></label>
              <ul>
                {
                  options.grade.features &&
                  options.grade.features.length &&
                  options.grade.features.map((item, index) => (
                  <li
                    key={`Featuer-${index}`}>
                    <Caption>{item.description}</Caption>
                  </li>
                ))}
              </ul>
              {
                finance && (
                  <div style={styles.financeOption}>
                    <img
                      style={styles.financeIcon}
                      src={finance.icon} />
                    <Caption>
                      {finance.description}
                    </Caption>
                  </div>
                )
              }
            </Content>
          </div>
        </div>
        {activeOption.description && (
          <div style={{ margin: '1.5em 0', fill: '#999999' }}>
            {showDescription && descriptionText(activeOption.description)}
            {step.specifications && <div>{downArrow()}</div>}
          </div>
        )}
      </div>
    )
  }
}

RenderConfiguredVehicle.propTypes = {
  display360: PropTypes.bool,
  step: PropTypes.object,
  isSelectColorInterior: PropTypes.bool,
  options: PropTypes.object,
  onChange: PropTypes.func,
  selectIndex: PropTypes.number,
  showDescription: PropTypes.bool,
  background: PropTypes.bool
}

RenderConfiguredVehicle.defaultProps = {
  display360: false,
  showDescription: false,
  background: false
}

export default Radium(RenderConfiguredVehicle)

const styles = {
  vehicleWrapper: {
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    minHeight: '300px',
    width: '100%'
  },
  statBase: {
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative'
  },
  vehicleBackground: compact => ({
    padding: compact ? '0' : '0 3em',
    margin: '0 auto',
    backgroundImage: compact ? '' : `url(${BackgroundImage})`,
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '50vw'
  }),
  description: {
    textAlign: 'center',
    margin: '0 0 1em 0',
    color: '#191919',
    fontWeight: '300',
    lineHeight: '1.5'
  },
  statList: {
    opacity: 1,
    overflow: 'hidden',
    transition: '.6s',
    display: 'inline-block',
    verticalAlign: 'middle',
    alignItems: 'center',
    pointerEvents: 'none',
    width: '100%'
  },
  feature: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e7e7e7",
    minHeight: "44px"
  },
  financeOption: {
    display: 'flex',
    marginTop: '18px',
    alignItems: 'center',
  },
  financeIcon: {
    marginRight: '10px',
    width: '15px'
  }
}



// WEBPACK FOOTER //
// ./src/containers/configured-vehicle-selector/render-config-vehicle.jsx